import ListContract from "features/Agent/Contract/List";

function ListContractScreen() {
  return <ListContract />;
}

export default ListContractScreen;
